import { Grid } from '@mui/material';
import { useSurveyFilters } from './hook';
import { SurveyFiltersProps } from './props';
import FieldText from '../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import dayjs from 'dayjs';

export const SurveyFilters = ({ onFilter, loading }: SurveyFiltersProps) => {
    const { formik } = useSurveyFilters(onFilter);

    const statusOptions = [
        { id: 'active', name: 'Activo' },
        { id: 'inactive', name: 'Inactivo' },
    ];

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Código"
                    name="code"
                    size="small"
                    touched={formik.touched.code}
                    errors={formik.errors.code}
                    value={formik.values.code}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Título"
                    name="title"
                    size="small"
                    touched={formik.touched.title}
                    errors={formik.errors.title}
                    value={formik.values.title}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldSelect
                    data={statusOptions}
                    label="Estado"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <DatePickerField
                    size="small"
                    label="Fecha Desde"
                    name="startDate"
                    touched={formik.touched.startDate}
                    errors={formik.errors.startDate}
                    value={
                        formik.values.startDate
                            ? dayjs(formik.values.startDate)
                            : null
                    }
                    onChange={(value: any) => {
                        formik.setFieldValue(
                            'startDate',
                            value ? value.format('YYYY-MM-DD') : ''
                        );
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <DatePickerField
                    size="small"
                    label="Fecha Hasta"
                    name="endDate"
                    touched={formik.touched.endDate}
                    errors={formik.errors.endDate}
                    value={
                        formik.values.endDate
                            ? dayjs(formik.values.endDate)
                            : null
                    }
                    onChange={(value: any) => {
                        formik.setFieldValue(
                            'endDate',
                            value ? value.format('YYYY-MM-DD') : ''
                        );
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
